// extracted by mini-css-extract-plugin
export default {"langToggle":"Toggle_langToggle__NrwY+","switch":"Toggle_switch__g+Dse","two":"Toggle_two__86Drb","three":"Toggle_three__QPXo9","langTag":"Toggle_langTag__Cuhjw"};